/**
 * Helper function to get user-friendly error messages for authentication errors
 * @param {Error|Object|string} error - Auth error
 * @returns {string} - A user-friendly error message
 */
export const getAuthErrorMessage = (error) => {
  if (!error) return 'Login failed. Please try again.';
  
  const errorCode = error?.code || '';
  const rawMessage = error?.message || String(error);
  const errorMessage = String(rawMessage || '').replace(/^Auth error:\s*/i, '').trim();
  
  // Check for invalid credential errors
  if (errorCode === 'auth/invalid-credential' || 
      errorCode === 'auth/wrong-password' || 
      errorCode === 'auth/user-not-found' ||
      errorMessage.includes('invalid-credential') ||
      errorMessage.includes('wrong-password') ||
      errorMessage.includes('user-not-found')) {
    return 'Invalid email or password. Please check your credentials and try again.';
  }

  // Friendly cooldown and rate-limit copy
  if (String(errorCode).includes('resource-exhausted') || errorMessage.toLowerCase().includes('please wait')) {
    return errorMessage || 'Please wait a moment before requesting another code.';
  }
  
  // Return the original message if it's not a credential error
  return errorMessage;
};
